"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CoveoFieldsHandler = (function () {
    function CoveoFieldsHandler(externalFields, prefix, suffix) {
        this.externalFields = externalFields;
        this.prefix = prefix;
        this.suffix = suffix;
        this.loadExternalFields(externalFields);
        this.prefix = prefix;
        this.suffix = suffix;
    }
    CoveoFieldsHandler.prototype.toCoveo = function (fieldName) {
        if (this.isValidFieldName(fieldName)) {
            var fieldWithoutDelimiter = this.stripCoveoFieldDelimiter(fieldName);
            var translatedFieldWithoutDelimiter = this.translateFieldName(fieldWithoutDelimiter);
            return this.startsWithAt(fieldName) ? this.addCoveoFieldDelimiter(translatedFieldWithoutDelimiter) : translatedFieldWithoutDelimiter;
        }
        else {
            console.error("Could not translate the '" + fieldName + "' field to a Coveo field. Returning as is.");
            return fieldName;
        }
    };
    CoveoFieldsHandler.prototype.addCoveoFieldDelimiter = function (fieldName) {
        var fieldNameWithDelimiter = fieldName;
        if (!this.startsWithAt(fieldName)) {
            fieldNameWithDelimiter = ("" + CoveoFieldsHandler.coveoFieldDelimiter + fieldName).toLowerCase();
        }
        return fieldNameWithDelimiter;
    };
    CoveoFieldsHandler.prototype.loadExternalFields = function (externalFields) {
        var _this = this;
        this.externalFields = [];
        externalFields.forEach(function (externalField) {
            if (typeof (externalField) === "string") {
                _this.externalFields.push({
                    "fieldName": externalField,
                    "shouldEscape": false
                });
            }
            else if (_this.isExternalFieldConfig(externalField)) {
                _this.externalFields.push(externalField);
            }
            else {
                console.error("Invalid external field '" + externalField + "'.");
            }
        });
    };
    CoveoFieldsHandler.prototype.isValidFieldName = function (fieldName) {
        return typeof (fieldName) !== "undefined" && fieldName !== "";
    };
    CoveoFieldsHandler.prototype.startsWithAt = function (fieldName) {
        return fieldName[0] === CoveoFieldsHandler.coveoFieldDelimiter;
    };
    CoveoFieldsHandler.prototype.stripCoveoFieldDelimiter = function (fieldName) {
        var field = fieldName;
        if (this.startsWithAt(fieldName)) {
            field = field.substr(1);
        }
        return field;
    };
    CoveoFieldsHandler.prototype.translateFieldName = function (fieldName) {
        var field = fieldName;
        if (this.shouldReplaceSpecialCharacters(fieldName)) {
            field = this.replaceSpecialCharacters(field);
        }
        if (this.shouldDecorate(fieldName)) {
            field = this.prefix + field + this.suffix;
        }
        return field;
    };
    CoveoFieldsHandler.prototype.replaceSpecialCharacters = function (fieldName) {
        return fieldName.split("")
            .map(this.replaceSpecialCharacter.bind(this))
            .join("");
    };
    CoveoFieldsHandler.prototype.replaceSpecialCharacter = function (character) {
        if (character.match(CoveoFieldsHandler.nonSpecialCharacters)) {
            return character;
        }
        else {
            return this.escapeSpecialCharacter(character);
        }
    };
    CoveoFieldsHandler.prototype.escapeSpecialCharacter = function (character) {
        return "z" + character.charCodeAt(0) + "x";
    };
    CoveoFieldsHandler.prototype.shouldReplaceSpecialCharacters = function (fieldName) {
        var fields = this.externalFields.filter(function (field) { return field.fieldName === fieldName; });
        return fields.length > 0 ? fields[0].shouldEscape : true;
    };
    CoveoFieldsHandler.prototype.shouldDecorate = function (fieldName) {
        return !this.externalFields.some(function (field) { return field.fieldName === fieldName; });
    };
    CoveoFieldsHandler.prototype.isExternalFieldConfig = function (obj) {
        return typeof (obj) !== "undefined" &&
            typeof (obj.fieldName) !== "undefined" &&
            typeof (obj.shouldEscape) !== "undefined";
    };
    return CoveoFieldsHandler;
}());
// 'z' and 'x' are also considered as special characters because
// they are used in the escaping logic. So we have to remove them
// from the regular expression pattern.
CoveoFieldsHandler.nonSpecialCharacters = /[a-wyA-WY0-9]/;
CoveoFieldsHandler.coveoFieldDelimiter = "@";
exports.CoveoFieldsHandler = CoveoFieldsHandler;



//////////////////
// WEBPACK FOOTER
// ./src/handlers/CoveoFieldsHandler.ts
// module id = 33
// module chunks = 13 14